import { combineRules } from 'fela'; // eslint-disable-line behance/no-deprecated
import { ThemeProvider, connect, withTheme } from 'react-fela'; // eslint-disable-line behance/no-deprecated
import { capitalize } from 'underscore.string';

import applyStaticStyles, { getDisplayName as getApplyStatisticStylesDisplayName } from './applyStaticStyles';
import applyTheme, { getDisplayName as getApplyThemeDisplayName } from './applyTheme';
import createComponent, { getDisplayName as getCreateComponentDisplayName } from './createComponent';
import createComponentStyles, { getDisplayName as getCreateComponentStylesDisplayName } from './createComponentStyles';
import createStyledComponent from './createStyledComponent';
import withRenderer, { getDisplayName as getWithRendererDisplayName } from './withRenderer';

export { createComponent, getCreateComponentDisplayName, applyTheme, getApplyThemeDisplayName, ThemeProvider, connect, combineRules, createComponentStyles, getCreateComponentStylesDisplayName, capitalize, withTheme, withRenderer, getWithRendererDisplayName, applyStaticStyles, getApplyStatisticStylesDisplayName, createStyledComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/cf-component-request-status-indicator/node_modules/@cloudflare/style-container/es/index.js
// module id = 491
// module chunks = 1